module.exports = __webpack_public_path__ + "static/media/share_wechat.91b4559f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/share_wechat.svg
 ** module id = 477
 ** module chunks = 0
 **/